/**
 * Pipeline doskasidagi lokal o'zgarishlar (sof funksiyalar). O'zgarmagan ustun va kartalar o'sha obyekt bo'lib
 * qoladi: memo qilingan ustun va kartalar qayta chizilmaydi (sudrash va tashlash silliq bo'lishi uchun).
 */
import type { DriverListItem, DriverStatus, PipelineColumn } from "@/features/drivers/types";

/** Kartani `to` ustuniga ko'chiradi (oxiriga), sonlarni moslaydi */
export function moveCard(columns: PipelineColumn[], driverId: number, to: DriverStatus, moved: DriverListItem): PipelineColumn[] {
  return columns.map((col) => {
    const had = col.drivers.some((d) => d.id === driverId);
    if (!had && col.status !== to) return col;
    const without = had ? col.drivers.filter((d) => d.id !== driverId) : col.drivers;
    if (col.status === to) return { ...col, drivers: [...without, moved], count: col.count - (had ? 1 : 0) + 1 };
    return { ...col, drivers: without, count: col.count - 1 };
  });
}

/** Serverdan kelgan yangi holat (versiya!) bilan kartani almashtiradi */
export function replaceCard(columns: PipelineColumn[], updated: Partial<DriverListItem> & { id: number }): PipelineColumn[] {
  return columns.map((col) =>
    col.drivers.some((d) => d.id === updated.id) ? { ...col, drivers: col.drivers.map((d) => (d.id === updated.id ? { ...d, ...updated } : d)) } : col,
  );
}
